import { credentialTypeShortLabel } from '../lib/humanLabels.js';

const PILL_TONE: Record<string, string> = {
  nfc_card: 'bg-secondary-container text-on-secondary-container',
  pin_code: 'bg-secondary-container text-on-secondary-container',
  mobile_key: 'bg-tertiary-fixed text-on-tertiary-fixed-variant',
  touch: 'bg-purple-100 text-purple-800',
};

interface Props {
  types: string[];
}

export function CredentialPills({ types }: Props) {
  if (types.length === 0) {
    return (
      <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold bg-error-container text-on-error-container">
        No credentials
      </span>
    );
  }
  return (
    <span className="inline-flex flex-wrap gap-1">
      {types.map((t) => {
        // PILL_TONE is a static local map with a safe nullish fallback — no injection risk.
        // eslint-disable-next-line security/detect-object-injection
        const tone = PILL_TONE[t] ?? 'bg-surface-container text-on-surface';
        return (
          <span
            key={t}
            className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold ${tone}`}
          >
            {credentialTypeShortLabel(t)}
          </span>
        );
      })}
    </span>
  );
}
